import { useMutation } from '@tanstack/react-query';
import type { JsonValue } from 'type-fest';

import { useRequest, type MutationFunction } from '@frontend/api';

import type { Action } from './types';

const getUseUpdateActionKey = () => ['rules', 'action', 'update'];

type Payload = Partial<Pick<Action, 'assigneeId' | 'selectedResolution'>> & {
  uuid: string;
};

/**
 * Mutation function for updating an Action.
 */
export const useUpdateAction: MutationFunction<Action, Payload> = ({
  requestOptions,
  queryOptions,
} = {}) => {
  const request = useRequest(requestOptions);

  // TODO: fix type error the right way
  return useMutation({
    mutationFn: ({ uuid, ...body }) =>
      request<Action & JsonValue>(`/rules/actions/${uuid}`, {
        init: {
          method: 'PATCH',
          body,
        },
      }),
    ...queryOptions,
    mutationKey: getUseUpdateActionKey(),
  });
};
